import { createFeatureSelector, createSelector } from '@ngrx/store'
import * as state from './user-signature.state'

export const userState = createFeatureSelector<state.State>('signature')

export const selectUsersLoaded = createSelector(userState, (state: state.State) => state.isLoaded)

export const selectCurrentSignatureUser = createSelector(userState, (state: state.State) => state.currentUser)
